import type { AccountView, JsonAccountStats } from 'src/store/shared/accounts/types';

// convert JsonAccountStats to AccountView

export const prepareAccounts = (accounts: JsonAccountStats[]): AccountView[] =>
  accounts.flatMap((item, idx) =>
    item.accounts.map((account) => ({
      name: String(account.id),
      label: account.name,
      status: item.status ?? 0,
      message: item.error ?? '',
      proxy: '',
      inviteLink: account.inviteLink ?? '',
      group: idx + 1,
      exchange: item.exchange,
      botType: account.botTypes[0] || undefined,
      ticker: account.ticker || undefined,
    })),
  );

const sortFunction = (a: AccountView, b: AccountView, sortKey: string) => {
  switch (sortKey) {
    case 'exchange:asc':
      return a.name.localeCompare(b.name);
    case 'exchange:desc':
      return b.name.localeCompare(a.name);
    default:
      return 0;
  }
};

const filterFunction = (item: AccountView, searchValueDefault: string) => {
  const parts = searchValueDefault.toLowerCase().split(' ');
  const itemString = `${item.name} ${item.label} `.toLowerCase();
  return parts.every((token) => itemString.includes(token));
};

export const getAccountsFilteredSortedData = (
  accounts: AccountView[],
  sortKey: string,
  searchValue: string,
) => {
  const filterData = (accounts || []).filter((pair) => {
    if (searchValue.length > 2 && !filterFunction(pair, searchValue)) {
      return false;
    }

    return true;
  });

  return filterData.toSorted((a, b) => sortFunction(a, b, sortKey));
};

export const tokensByAccounts = (stats: JsonAccountStats[] = []) =>
  stats.reduce<Record<string, [string, string]>>((acc, { accounts }) => {
    accounts.forEach(({ id, ticker }) => {
      const [token1, token2] = (ticker || '').split('/');
      acc[id] = [token1, token2];
    });
    return acc;
  }, {});
